import { PagePrompt, Typography } from '@weareopenr/component-library';
import styles from './ErrorPage.module.scss';
import { useNavigate } from 'react-router-dom';

export const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <PagePrompt
      title="Oops"
      primaryButton={{
        text: 'Go to dashboard',
        onClick: () => navigate('/'),
      }}
    >
      <div className={styles['message-container']}>
        <Typography size="medium" weight="bold">
          Something didn&apos;t go as planned.
        </Typography>
        <Typography size="medium">
          Try again in a moment. If this keeps happening, please contact our support team.
        </Typography>
      </div>
    </PagePrompt>
  );
};
